import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { PopUpLoaderComponent } from './pop-up-loader.component';
import { AnimatedSvgModule } from 'src/app/components/animated-svg/animated-svg.module';

@NgModule({
  declarations: [PopUpLoaderComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    AnimatedSvgModule
  ],
  exports:[PopUpLoaderComponent]
})
export class PopUpLoaderModule { }
